module.exports = __webpack_public_path__ + "img/4-3.ab7cb690.png";